import ContainerWithTabs from './ContainerWithTabs';

export default ContainerWithTabs;
